import { useEffect } from 'react';

export default function useResponsiveTables() {
    useEffect(() => {
        const applyLabels = () => {
            document.querySelectorAll("table").forEach(table => {
                const headers = Array.from(table.querySelectorAll("thead th")).map(h =>
                    h.innerText.trim()
                );

                table.querySelectorAll("tbody tr").forEach(row => {
                    Array.from(row.children).forEach((cell, i) => {
                        cell.setAttribute("data-label", headers[i] || "");
                    });
                });
            });
        };

        // Run once on mount
        applyLabels();

        // Watch for DOM changes (React updates tables frequently)
        const observer = new MutationObserver(applyLabels);
        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);
}
